import React from 'react'
import './SearchPage.css'
import { AiOutlineArrowLeft, AiFillFire } from "react-icons/ai";
import { useNavigate } from 'react-router-dom';

function SearchPage() {
    const trendingItems = ['Eyeglass', 'Sunglass', 'Round Glass', 'Lens']
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1)
    }
    return (
        <div className='search_page'>
            <div className='search_input'>
                <AiOutlineArrowLeft className='arrow' onClick={handleBack} />
                <form>
                    <input type="text" placeholder='Search for Eyeglasses, Sunglasses and more..' />
                </form>
            </div>

            <div className='trending_data'>
                <p className='trending'>trending</p>
                {
                    trendingItems.map((itemName, index) => {
                        return (
                            <div className='trending_item'>
                                <AiFillFire className='trending_icon' />
                                <p>{itemName}</p>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default SearchPage